import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';

// Import all providers
import { AppProvider } from './context/AppContext';
import { SidebarProvider } from './context/AdminContext';

import './assets/css/admin/adminDashboard/dashboardvariables.css';
import { SettingsProvider } from './context/SettingsContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
                {/* Authentication */}
        <AppProvider>         {/* Context */}
          <SidebarProvider>
           
              <SettingsProvider>
                
                  <App />

              </SettingsProvider>  {/* UI/Sidebar Context */}
             {/* Main App Component */}
          </SidebarProvider>
        </AppProvider>
    </BrowserRouter>
  </React.StrictMode>

);